/**
 * The server's mention-id shape (#1599 Story 1.4, closing deferred-work
 * `:4416`): a canonical positive decimal of at most ten digits, no sign, no
 * leading zero, and at most `users.user_id`'s INT ceiling. The client's mirror
 * of `correspondenceSanitizer.ts`'s `MENTION_USER_ID` / `isMentionUserId`,
 * duplicated under the house workaround and pinned equal in
 * `messageHtml.test.ts`. The send path does NOT apply it (the server is
 * authoritative on shape); the editor's Mention node does, in its
 * `parseHTML`, so a `__proto__` or `1e3` id seeded into the composer stays
 * plain text and is never offered back as a token.
 *
 * ⚠️ PURE ON PURPOSE (#1599 Story 3.1). Moved here out of `messageHtml.ts`,
 * which imports `react-native`, because the 10tap WebView bundle
 * (`editor-web/`, built by vite for a browser) reaches this predicate through
 * `siteScopeMention.ts` and cannot resolve `react-native`. Nothing may be
 * imported into this file. `messageHtml.ts` re-exports all three unchanged,
 * so every existing import and the parity pin stand as they were.
 */
export const MENTION_USER_ID = /^(?:[1-9]\d{0,9})$/;
export const MENTION_USER_ID_MAX = 2147483647;
export const isMentionUserId = (value: string): boolean =>
  MENTION_USER_ID.test(value) && Number(value) <= MENTION_USER_ID_MAX;
